import React from 'react';
import './UlList.scss';

const addLists = (props, listItem, index, listItemClass) => {
    return (<li
        key = {(listItem.value) + index}
        className = {listItemClass}
        value = {listItem.value}
        title = {props.listItemTitle ? props.listItemTitle : (listItem.name ? listItem.name : listItem.value)}
        onClick = {(e) => {props.onListItemClick(e)} }
    >
        {listItem.name ? listItem.name : listItem.value }
    </li>);
}

const UlList = (props) => {
    return (
        <ul
            className = {props.listContainerClass ? props.listContainerClass : ''}
            {...props.listContainerProps}
        >
            {props.listItems.map((listItem, index) => {
                return addLists(props, listItem, index, props.listItemClass)
            })}
        </ul>
    );
}

export default UlList;